<template>
  <ConnectAccountsLayout v-if="bankAccount" :show-product-message="false">
    <template #titles>
      <h2 :class="$style.heading">Bank Statements</h2>
      <p :class="$style['sub-heading']">
        Please upload the <strong>last 6 months of bank statements</strong> for
        bank account
        <strong>
          {{ bankAccount.subtype }} account *** ***
          {{ bankAccount.accountNumberLast4 }}
        </strong>
      </p>
    </template>
    <BankUploadStatementsForm
      show-date-range
      :meta-id="bankAccount.id"
      :account-number="bankAccount.accountNumberLast4"
      :event-tracking-fields="commonTrackingFields"
    />
    <div
      class="c-form"
      :style="{
        textAlign: 'center',
      }"
    >
      <div class="c-form__controls justify-center" :style="{ margin: '0' }">
        <DSButton
          class="p-button-outlined"
          :label="$t('common.buttons.back')"
          @click="backClick"
        />
        <DSButton
          :disabled="!isUploadBankStatementsStepComplete"
          :label="
            isInFinancialDocsSegment
              ? $t('common.buttons.next')
              : $t('common.buttons.done')
          "
          @click="done"
        />
      </div>
    </div>
  </ConnectAccountsLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import DSButton from 'primevue/button';
import { RouteNames } from '@/data/routes';
import { useToast } from '@/composables/useToast';
import ConnectAccountsLayout from '@/components/layouts/ConnectAccountsLayout.vue';
import BankUploadStatementsForm from '@/pages/banking/components/BankUploadStatementsForm.vue';

export default {
  components: {
    DSButton,
    ConnectAccountsLayout,
    BankUploadStatementsForm,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  async beforeMount() {
    if (!this.bankAccount) {
      this.toast.warn('Bank account not found');
      await this.$router.push({ name: RouteNames.BANKING.INDEX });
    }
  },
  async mounted() {
    await this.$store.dispatchApiAction('GET_FISCAL_DOCUMENT_CHECKS');
  },
  computed: {
    ...mapGetters([
      'isUploadBankStatementsStepComplete',
      'bankAccounts',
      'isInFinancialDocsSegment',
      'productSegmentLabel',
      'experimentName',
    ]),
    bankId() {
      return this.$route.params.id;
    },
    bankAccount() {
      return this.bankAccounts.find(
        (bank) => bank.id.toString() === this.bankId,
      );
    },
    commonTrackingFields() {
      return {
        productSegment: this.productSegmentLabel,
        experiment: this.experimentName,
        targetArea: this.$route.name,
      };
    },
  },
  methods: {
    navigationLocation(defaultRoute) {
      const routeName = this.$route.query.navigatedFrom || defaultRoute;
      this.$router.push({ name: routeName });
    },
    done() {
      this.navigationLocation(RouteNames.PROFILE.INDEX);
    },
    backClick() {
      this.navigationLocation(RouteNames.BANKING.INDEX);
    },
  },
};
</script>

<style lang="less" module>
h2.heading {
  font-size: 21px;
  line-height: 30px;
  font-weight: 500;
  margin: 0 0 24px;
}

.sub-heading {
  margin: 0 auto 2rem;
  max-width: 550px;
}

@media screen and (max-width: 500px) {
  h2.heading,
  .sub-heading {
    text-align: left;
  }
}
</style>
